import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import analyticsService from "../services/analyticsService";
import { buildSupportWhatsAppUrl } from "../constants/support";
import StatusScreen from "./ui/StatusScreen";
import Button from "./ui/Button";

// Erreur générique de la maquette : « Réessayer » quand il y a une page où revenir,
// puis le service client sur WhatsApp.
export function GenericErrorScreen({ text, onRetry }) {
  const { t } = useTranslation();

  return (
    <StatusScreen image="/Danger_Circle_Red.svg" tone="danger" title={t("genericErrorTitle")} text={text || t("errorPage.text")}>
      {onRetry && <Button onClick={onRetry}>{t("errorPage.retry")}</Button>}
      <Button
        variant="whatsapp"
        icon="whatsapp"
        href={buildSupportWhatsAppUrl(t, {})}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => analyticsService.pushEvent("support_whatsapp_clicked", { error_type: "error_page" })}
      >
        {t("support.whatsapp")}
      </Button>
    </StatusScreen>
  );
}

export default function ErrorComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { errorText, message, notFound } = location.state || {};
  const { t } = useTranslation();

  // Adresse qui ne correspond à aucune borne (borne inconnue ou URL inexistante).
  if (notFound) {
    return <StatusScreen image="/Map_Point.svg" title={t("notFoundPage.title")} text={t("notFoundPage.text")} />;
  }

  // Ouverte directement, la page d'erreur n'a pas de page précédente à recharger.
  const canGoBack = (window.history.state?.idx ?? 0) > 0;

  return <GenericErrorScreen text={errorText || message} onRetry={canGoBack ? () => navigate(-1) : undefined} />;
}
